module.exports = __webpack_public_path__ + "img/50.a6a62b29.jpg";